export { default } from './TextLockup'
